(() => {
  const productLinkSelector = 'a.apo-swatch-url';
  const storeHostname = 'www.tmgindustrial.com';
  const shopifyRouteRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  const themeRouteRoot = window.Theme && window.Theme.routes && window.Theme.routes.root_url;
  const routeRoot = typeof shopifyRouteRoot === 'string' ? shopifyRouteRoot : themeRouteRoot;

  if (typeof routeRoot !== 'string') return;

  const localePath = routeRoot.replace(/^\/+|\/+$/g, '');
  const localePrefix = localePath ? `/${localePath}` : '';

  const localizeProductLink = (link) => {
    const href = link.getAttribute('href');

    if (!href) return;

    let url;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    const isStoreUrl = url.origin === window.location.origin || url.hostname === storeHostname;

    if (!isStoreUrl || !url.pathname.startsWith('/products/')) return;

    const localizedHref = `${localePrefix}${url.pathname}${url.search}${url.hash}`;

    if (href !== localizedHref) link.setAttribute('href', localizedHref);
  };

  const processNode = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (node.matches(productLinkSelector)) localizeProductLink(node);
    node.querySelectorAll(productLinkSelector).forEach(localizeProductLink);
  };

  document.querySelectorAll('[data-product-wrapper] [data-product-form-area]').forEach((productFormArea) => {
    processNode(productFormArea);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(processNode);
      });
    });

    observer.observe(productFormArea, { childList: true, subtree: true });
  });
})();
